import _ from "lodash";
import { CustomerOrderVehicleItemInfo } from "../../../../model/OrderManagement/CustomerOrder";
import { dateFormat } from "../../../../shared/utils/Dates/format";
/**
 * 제품상세페이지- 호환모델 연도 표기
 */
export const getModelYr = (model?: CustomerOrderVehicleItemInfo) => {
  if (model?.vehicleRegistrationType === "SELECT") {
    const { startYear, endYear } = model;
    if (startYear === endYear) {
      // 두 연도가 같으면 하나만
      return `${dateFormat(startYear, "YY년")}`;
    }
    // 서로다른연도 혹은 하나만 있을때 처리
    const start = dateFormat(startYear, "YY년~");
    const end = dateFormat(endYear, "~YY년");
    const strYr = _([start, end])
      .filter((item) => item !== "-")
      .uniq()
      .join("")
      .replace("~~", "~");
    return strYr.endsWith("~") ? `${strYr}현재` : strYr;
  }
  return undefined;
};

/**
 * 모델연도 파싱처리 - start, end 가 없으면 modelYear 호출
 * @sample startYear-endYear -> YY년~YY년(|| 현재)
 * @sample modelYear -> YY년
 * @param model
 * @returns
 */
export const getModelAllYr = (model?: CustomerOrderVehicleItemInfo) => {
  return (
    getModelYr(model) ||
    (model?.modelYear && `${model?.modelYear?.slice(-2)}년`) ||
    undefined
  );
};
